var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"load-more-btn d-flex align-center justify-center"},_vm.$listeners),[_c('h5',{staticClass:"h5 text-strong"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }